// extracted by mini-css-extract-plugin
module.exports = {"component":"brand-teasers_component__Nvake","container":"brand-teasers_container__WBe0_","headline":"brand-teasers_headline___WZ0i","row":"brand-teasers_row__dFKhm"};